import { ChangeDetectionStrategy, Component, HostBinding, Input, OnInit } from '@angular/core';

import { AlertType } from '../models';

@Component({
    selector: 'bs-alert',
    templateUrl: './alert.component.html',
    styleUrls: ['./alert.component.scss'],
    changeDetection: ChangeDetectionStrategy.OnPush,
    standalone: false,
})
export class AlertComponent implements OnInit {
    private static warningClass = 'alert--warning';
    private static informationClass = 'alert--information';
    private static errorClass = 'alert--error';
    private static successClass = 'alert--success';

    @HostBinding('class') className = AlertComponent.warningClass;

    @Input() title: string | null;
    @Input() message: string;
    @Input() type: AlertType;

    ngOnInit(): void {
        this.className = this.mapAlertTypeToClass(this.type);
    }

    private mapAlertTypeToClass(type: AlertType): string {
        switch (type) {
            case AlertType.Warning:
                return AlertComponent.warningClass;
            case AlertType.Information:
                return AlertComponent.informationClass;
            case AlertType.Error:
                return AlertComponent.errorClass;
            case AlertType.Success:
                return AlertComponent.successClass;
        }
    }

    getIcon(type: AlertType): string {
        switch (type) {
            case AlertType.Warning:
                return 'theme-warning';
            case AlertType.Information:
                return 'theme-info-i';
            case AlertType.Error:
                return 'theme-error-i';
            case AlertType.Success:
                return 'theme-success-i';
        }
    }
}
